import { Button } from '@/components';
import H1 from '@/components/heading/H1';
import React from 'react';
import * as styles from './index.module.less';
import { PublicArrowRightTail } from 'notta-web-icon';
import { WEB_APP_JP_SIGN_UP_URL } from '@/constants';
import RatioMedia from '@/components/ratio-media';
// import HonorPart from '../honor-part';

const HeroBanner = () => {
  return (
    <div className={styles.banner_layout}>
      <div className={styles.banner_container}>
        {/* 标题文字以及图片的容器 */}
        <div className={styles.content_cover_container}>
          <div className={styles.banner_content}>
            <H1>
              自動的に
              <wbr />
              音声を文字起こし
            </H1>
            <div className={styles.hero_desc}>
              <p style={{ marginBottom: '0px' }}>
                Notta
                <wbr />は<wbr />
                高精度
                <wbr />の<wbr />
                音声認識
                <wbr />と<wbr />
                AI要約機能
                <wbr />を<wbr />
                使って、
                <wbr />
                1時間
                <wbr />の<wbr />
                音声
                <wbr />を<wbr />
                わずか
                <wbr />
                5分
                <wbr />で<wbr />
                文字起こし・
                <wbr />
                要約します。
                <wbr />
                商談
                <wbr />や<wbr />
                Web会議
                <wbr />の<wbr />
                議事録作成
                <wbr />を<wbr />
                簡易化し、
                <wbr />
                情報共有
                <wbr />を<wbr />
                効率的に
                <wbr />
                行います。
              </p>
            </div>
            <div className={styles.meeting_tools}>
              <img
                src="https://www.notta.ai/pictures/jp-homepage-hero-tips-202406121630.png"
                alt="リアルタイム録音·音声ファイル·Web会議文字起こし·同時翻訳"
              />
              <img
                src="https://www.notta.ai/pictures/transliteration-form-middle-202406121634.png"
                alt="リアルタイム録音·音声ファイル·Web会議文字起こし·同時翻訳"
              />
            </div>
            <div className={styles.btn_link_container}>
              <a href={WEB_APP_JP_SIGN_UP_URL} data-gtm="home-page-banner-sign-up-btn">
                <Button gradual type="primary">
                  いますぐ無料で始める
                </Button>
              </a>
              <a href="/pricing" data-gtm="home-page-banner-pricing-btn">
                <Button type="link" className={styles.pricing_btn}>
                  無料・有料機能比較 <PublicArrowRightTail style={{ marginLeft: '4px' }} size={18} />
                </Button>
              </a>
            </div>
          </div>
          <div className={styles.banner_cover}>
            <RatioMedia
              media={{
                type: 'image',
                src: 'https://www.notta.ai/pictures/home-page-jp-hero-banner-v3-202404172000.jpg',
                alt: '文字起こし サービス Notta',
                objectFit: 'contain',
              }}
              ratio={3 / 4}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
